var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import StarIcon from "@mui/icons-material/Star";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Property from "./Property";
var OrganizationUrlsField = function (_a) {
    var _b = _a.urls, urls = _b === void 0 ? [] : _b, setUrls = _a.setUrls;
    var t = useTranslation().t;
    var fieldGroupGap = { xs: 3, sm: 2.5 };
    var primaryTitle = function (title) { return (_jsxs(Stack, __assign({ component: 'span', direction: 'row', gap: 0.5, alignItems: 'center', sx: { display: 'inline-flex' } }, { children: [_jsx(StarIcon, { sx: { fontSize: '1em', lineHeight: 1, flexShrink: 0 } }), _jsx("span", { children: title })] }))); };
    return (_jsxs(Stack, __assign({ gap: fieldGroupGap }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', fontWeight: 'bold', textAlign: 'start' }, { children: t('Urls') })), urls.map(function (url, index) {
                var _a, _b;
                var provider = (_b = (_a = url.externalInfo) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.provider;
                var disabled = !!provider;
                return (_jsx(Property, __assign({ orientation: 'vertical', title: url.isPrimary ? primaryTitle(t('Primary url')) : "".concat(t('Url'), " ").concat(index + 1), subtitle: provider, sx: {
                        title: {
                            fontWeight: 'bold'
                        }
                    } }, { children: _jsxs(Stack, __assign({ gap: 1, width: '100%' }, { children: [_jsx(Property, __assign({ title: t('Url'), labelAlignment: 'top' }, { children: _jsx(TextField, { id: "organization-url-".concat(index), "data-testid": "organization-url-".concat(index), size: 'small', type: 'url', value: url.url || '', onChange: function (e) {
                                        var updatedUrls = __spreadArray([], urls, true);
                                        updatedUrls[index] = __assign(__assign({}, updatedUrls[index]), { url: e.target.value });
                                        setUrls(updatedUrls);
                                    }, placeholder: 'https://hotel.example/restaurant', fullWidth: true, disabled: disabled }) })), !disabled && (_jsxs(Stack, __assign({ direction: 'row', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }, { children: [!url.isPrimary && (_jsx(Button, __assign({ variant: 'text', size: 'small', onClick: function () {
                                            setUrls(urls.map(function (entry, urlIndex) { return (__assign(__assign({}, entry), { isPrimary: urlIndex === index })); }));
                                        } }, { children: t('Set as primary') }))), _jsx(Button, __assign({ variant: 'text', size: 'small', color: 'error', onClick: function () {
                                            var updatedUrls = __spreadArray([], urls, true);
                                            updatedUrls.splice(index, 1);
                                            setUrls(updatedUrls);
                                        } }, { children: t('Delete') }))] })))] })) }), index));
            }), _jsx(Button, __assign({ startIcon: _jsx(AddIcon, {}), onClick: function () { return setUrls(__spreadArray(__spreadArray([], urls, true), [
                    { url: '', isPrimary: urls.length === 0 }
                ], false)); }, sx: { alignSelf: 'flex-start' } }, { children: t('Add url') }))] })));
};
export default OrganizationUrlsField;
